export const blockIconsMapsAddLocationNew = (
	<span className='material-symbols-outlined'>add_location</span>
);
